<template>
  <div class="gp-has-header" v-if="settings">
    <div v-if="loggedIn && !translationMode">
      <mdb-spinner/>
    </div>

    <mdb-card class="mb-4" v-if="translationMode" style="width:100%">
      <mdb-card-header>
        <h4>Translation Mode</h4>
      </mdb-card-header>
      <mdb-card-body>
        <div class="text-info">
          You are currently logged in, but this page is visible to you for translation purposes.
        </div>
        <translate-section category="page" sub-category="registration" v-if="translationMode" />
      </mdb-card-body>
    </mdb-card>

    <div v-if="showVerification">
       <p> {{ $t("page.registration.checkEmail",{email: user.email}) }}</p>

    </div>

    <div class="login-form" v-if="settings && (settings.identityProvider == 'LOCAL' || $route.query.localForm=='Y' || translationMode)">
      <div v-if="(!loggedIn || translationMode) && showRegistration">
        <mdb-card class="mb-4" style="width:100%">
          <mdb-card-header>
            <p class="h5">{{ $t("page.registration.createAccount")}}</p>
            <translate-modal v-if="translationMode" category="page" sub-category="registration" name="createAccount"/>
          </mdb-card-header>
          <mdb-card-body>
            <div>
              <a href="" @click.prevent="$router.push('/page/tos')">{{ $t("common.label.termsOfService")}}</a>
              <translate-modal v-if="translationMode" category="common" sub-category="label" name="termsOfService"/>
              &nbsp; &bull; &nbsp;
              <a href="" @click.prevent="$router.push('/page/privacy')">{{ $t("common.label.privacyPolicy")}}</a>
              <translate-modal v-if="translationMode" category="common" sub-category="label" name="privacyPolicy"/>
            </div>
            <div>
              <small>{{ $t("page.registration.alreadyHaveAccount")}}  <translate-modal v-if="translationMode" category="page" sub-category="registration" name="alreadyHaveAccount"/>
                <router-link to="/login">{{ capitalize($t("common.button.login"))}}</router-link>
                <translate-modal v-if="translationMode" category="common" sub-category="button" name="login"/>
              </small>
            </div>
            <form class="text-left needs-validation" v-on:submit.prevent="doRegister">
              <div class="grey-text text-left">
                <mdb-input v-model="user.name" icon="id-card-alt"
                           :label="capitalize($t('common.label.name'))"
                           name="name"
                           required :small="$t('page.registration.namePlaceholder')"
                           type="text">
                  <translate-modal slot="append" v-if="translationMode" category="page" sub-category="registration" name="namePlaceholder"/>
                </mdb-input>
                <mdb-input v-model="user.email" icon="envelope"
                           :label="capitalize($tc('common.label.emailAddress',1))"
                           name="email"
                           required :small="$t('page.registration.emailPlaceholder')"
                           type="text">
                  <translate-modal slot="append" v-if="translationMode" category="page" sub-category="registration" name="emailPlaceholder"/>
                </mdb-input>

                <mdb-input v-model="user.password" icon="lock"
                           :label="capitalize($t('common.label.password'))"
                           name="password"
                           :placeholder="$t('page.registration.pickPassword')"
                           required type="password">
                  <translate-modal slot="append" v-if="translationMode" category="page" sub-category="registration" name="pickPassword"/>
                </mdb-input>
                <mdb-input v-model="user.confirmPassword" icon="lock"
                           name="confirmPassword"
                           :placeholder="$t('page.registration.retypePassword')"
                           required
                           type="password">
                  <translate-modal slot="append" v-if="translationMode" category="page" sub-category="registration" name="retypePassword"/>
                </mdb-input>
                <p v-if="settings && settings.recaptchaEnabled && settings.recaptchaSiteKey">
                  {{ $t("common.checkbox.confirmHuman") }}<br/>
                  <VueRecaptcha
                                :loadRecaptchaScript="true"
                                :sitekey="settings.recaptchaSiteKey" size="compact"
                                theme="light"
                                @expired="expiredRecaptcha"
                                @verify="gotRecaptcha"/>

                </p>
                <div class="form-check">
                  <input id="tosAgree" v-model="tosAgree" class="form-control form-check-input"
                         type="checkbox"/>
                  <label for="tosAgree">{{ $t("page.registration.tosAgree")}}</label>
                  <translate-modal slot="append" v-if="translationMode" category="page" sub-category="registration" name="tosAgree"/>
                </div>

                <div class="text-info small" v-if="!passwordConforms">
                  <div class="text-danger">{{ $t("page.registration.passwordNotConform")}}</div>
                  <div class="gp-user-text-bold">{{ $t("page.registration.passwordPolicy") }}</div>
                  <div v-if="passwordPolicy.minimumLength">{{ $t("page.registration.minimumCharacters", {number: passwordPolicy.minimumLength })}}</div>
                  <div v-if="passwordPolicy.requireNumbers">{{ $t("page.registration.minimumNumbers")}}</div>
                  <div v-if="passwordPolicy.requireUppercase">{{ $t("page.registration.minimumLowercase")}}</div>
                  <div v-if="passwordPolicy.requireLowercase">{{ $t("page.registration.minimumUppercase")}}</div>
                  <div v-if="passwordPolicy.requireSymbols">{{ $t("page.registration.minimumSymbols")}}</div>
                </div>

                <mdb-btn :disabled="!tosAgree || translationMode || !user.name || !user.email || !user.password || !user.confirmPassword || !passwordConforms"
                         type="submit">{{ $t("common.button.register")}}
                </mdb-btn> <translate-modal v-if="translationMode" category="common" sub-category="button" name="register"/>
              </div>

            </form>
          </mdb-card-body>
        </mdb-card>
      </div>
      <mdb-modal v-if="showTimezoneSelector" @close="showTimezoneSelector=false">
        <mdb-modal-header :close="true">
          Select Your Time Zone
        </mdb-modal-header>
        <mdb-modal-body>
          <timezone-select :clickHandler="timezoneSelected"></timezone-select>
        </mdb-modal-body>
      </mdb-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbSpinner,
  mdbView
} from 'mdbvue';
import timezone from '../services/timezone'
import timezoneSelect from '../components/common/TimezoneSelect'
import gpSelect from '../components/common/GPSelect'
import iso from "iso-3166-1"
import VueRecaptcha from 'vue-recaptcha';
import gpCookie from '../services/gpCookie'
import api from "../services/groupsPlaceApi";
import {CognitoAuth} from "amazon-cognito-auth-js";
import store from "../store";
import security from "../services/security";
import TranslateModal from "./common/TranslateModal";
import TranslateSection from "./common/TranslateSection";

export default {
  name: 'Register',
  components: {
    TranslateModal,
    TranslateSection,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbIcon,
    mdbCardHeader,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbView,
    mdbMask,
    mdbSpinner,
    gpSelect,
    timezoneSelect,
    VueRecaptcha
  },
  computed: {
    apiKey: function () {
      return this.$store.state.apiKey
    },
    userDetails: function () {
      return this.$store.state.userDetails
    },
    loggedIn: function () {
      return this.$store.state.loggedIn
    },
    settings: function () {
      return this.$store.state.settings
    },
    isDevelopment: function () {
      return process.env.NODE_ENV === 'development'
    },
    security: function() {
      return security
    },
    translationMode: function() {
      return this.$store.state.translationMode
    },
    language: function() {
      return this.$store.state.language
    },
    passwordConforms: function() {
      if (!this.passwordPolicy) return true
      if (this.passwordPolicy.minimumLength) {
        if (! this.user.password) return false
        if (this.user.password.length < this.passwordPolicy.minimumLength) return false
      }

      if (this.passwordPolicy.requireNumbers) {
        let matches = this.user.password.match(/\d+/g);
        if (!matches) return false
      }

      if (this.passwordPolicy.requireUppercase) {
        if (!(/[A-Z]/.test(this.user.password))) return false
      }

      if (this.passwordPolicy.requireLowercase) {
        if (!(/[a-z]/.test(this.user.password))) return false
      }


      if (this.passwordPolicy.requireSymbols) {
        let specialCharacters = ["^", "$", "*", ".", "[", "]", "{",  "}", "(", ")", "?",
          "-", "\"", "!", "@", "#", "%", "&", "/", "\\", ",", ">", "<", "'", ":",",",";","|","_","~","`","+","="]
      }

      return true

    }
  },

  data() {
    return {
      affiliateCode: null,
      user: {
        username: "",
        email: "",
        name: "",
        timezone: null,
        country: "",
        city: "",
        postal: "",
        password: "",
        confirmPassword: "",
        recaptcha: null,
        affiliateCode: null
      },
      countries: [],
      showTimezoneSelector: false,
      showRegistration: true,
      tosAgree: false,
      showVerification: false,
      verificationCode: "",
      registrationId: "",
      passwordPolicy: {}
    }
  },
  beforeMount() {
    this.user.timezone = timezone.detectTimeZone()
    if (this.user.timezone) {
      gpCookie.setCookie("timezone", this.user.timezone, 5)
    }
    if (this.user.timezone) {
      let tz = this.user.timezone
      if (tz.startsWith("America/")) this.user.country = 'usa'
      if (tz.startsWith("Europe/")) this.user.country = 'gbr'
      if (tz.startsWith("Australia/")) this.user.country = 'aus'
      if (tz.startsWith("Asia/")) this.user.country = 'hkg'
    }
    for (let i = 0; i < iso.all().length; i++) {
      let row = iso.all()[i]
      let c = {text: row.country, value: row.alpha3.toLowerCase()}
      this.countries.push(c)
    }
  },
  mounted() {

    document.title = "Register"
    if (this.loggedIn) {
      if (!this.translationMode ) {
        this.$router.push("/")
        return
      }
    }
    this.affiliateCode = window.localStorage.getItem("affiliate")

    if (this.$route.query.complete) {
      this.finalizeRegistration()
      return
    }

    if (this.settings.identityProvider == "COGNITO" && this.$route.query.localForm != 'Y' && !this.$route.query.complete) {
      this.cognitoLogin()
      return
    }
    /*if (navigator.geolocation) {
     navigator.geolocation.getCurrentPosition(function (position) {
     console.log("Got position ", position)
     })
     }*/

    axios.get(process.env.BACKEND_URL + "/api/v1/user/passwordPolicy").then(
      (details) => {
        this.passwordPolicy = details.data
      },
      (error) => {
        console.error("Error getting password pollicy", error)
      }).then(() => {
    })


  },
  watch: {
    settings(n, o) {
      if (!o || !o.identityProvider) {
        if (n.identityProvider == "COGNITO" && this.$route.query.localForm != 'Y' && !this.$route.query.complete) {
          this.cognitoLogin()
        }
      }
    }
  },
  methods: {
    cognitoLogin() {
      let auth = new CognitoAuth(this.settings.cognitoAuthData);
      auth.userhandler = {
        onSuccess: (result) => {
          store.dispatch("setCognitoAuth", auth)
          axios.post(process.env.BACKEND_URL + "/user/cognitoLogin",
                   {token: auth.getSignInUserSession().getIdToken().jwtToken, affiliate: this.affiliateCode},
                   {withCredentials: true}).then(
            (details) => {
              let key = details.data.authKey
              let isNewUser = details.data.isNewUser
              if (key) {
                api.completeLogin(key, details.data.secret, isNewUser)
              } else this.error = "Invalid response from server."
            },
            (error) => {
              this.$notify.error({message: error.response.data, timeOut: 4000})
            })
        },
        onFailure: function (err) {
          this.$store.commit("loggedIn", false)
          this.$router.push("/")
        }
      };
      auth.getSession();
    },

    timezoneSelected: function (tz) {
      this.user.timezone = tz
      this.showTimezoneSelector = false
    },
    gotRecaptcha: function (recap) {
      this.user.recaptcha = recap
    },
    expiredRecaptcha: function () {
      this.user.recaptcha = null
    },
    doRegister: function () {
      if (this.user.password != this.user.confirmPassword) {
        this.$notify.error({message: "Passwords don't match", timeOut: 8000})
        return
      }

      if (this.settings.recaptchaEnabled && this.settings.recaptchaSiteKey && !this.user.recaptcha ) {
        this.$notify.error({message: "Please confirm that you are a human.", timeOut: 8000})
        return
      }

      this.$store.dispatch("setExecuting", true)
      this.showRegistration = false
      if (this.affiliateCode) this.user.affiliateCode = this.affiliateCode
      this.user.language = this.language
      axios.put(process.env.BACKEND_URL + "/api/v1/user/register", this.user, {withCredentials: true}).then(
        (details) => {
          this.registrationId = details.data.registrationId
          this.showVerification = true
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
          this.showRegistration = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    finalizeRegistration: function () {
      this.$store.dispatch("setExecuting", true)
      this.showRegistration = false
      if (this.affiliateCode) this.user.affiliateCode = this.affiliateCode
      axios.put(process.env.BACKEND_URL + "/api/v1/user/finalizeRegistration", {verificationCode: this.$route.query.complete,
        affiliateCode: this.affiliateCode}, {withCredentials: true}).then(
        (details) => {
          let auth = details.data.authKey
          if (auth) {
            localStorage.setItem("apiKey", auth)
            localStorage.setItem("secret", details.data.authSecret)
            this.$store.dispatch("setApiKey", auth)
            this.$store.dispatch("setLoggedIn", true)
            this.$store.dispatch("setSecret", details.data.authSecret)
            api.getUserDetails()
            this.$router.push("/new-user")
          } else this.error = "Invalid response from server."
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
          this.showRegistration = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 749px ) {
  .login-form {
    margin: auto;
    width: 80%;

  }
}

@media screen and (min-width: 750px ) {
  .login-form {
    margin: auto;
    width: 50%;
  }
}
</style>
